import InventoryFilterAdvancedFilterLabel from './InventoryFilterAdvancedFilterLabel';

export default InventoryFilterAdvancedFilterLabel;
export { InventoryFilterAdvancedFilterLabel };
